const TextLeftActive = ({quat}) => {
   return (
      <>

     <svg width="210" height="177" viewBox="0 0 210 177" fill="none" xmlns="http://www.w3.org/2000/svg">
<line y1="176.219" x2="210" y2="176.219" stroke="url(#paint0_linear_2001_189)" strokeWidth="1.56134"/>
<path d="M82.0312 46.7317L163.446 93.7401L163.447 112.018L82.0323 65.0092L82.0312 46.7317Z" fill="#6E6E6E"/>
<path d="M0.615692 93.7385L82.0307 46.7301L82.0297 65.0076L0.614653 112.016L0.615692 93.7385Z" fill="#5A5A5A"/>
<rect width="94.0117" height="94.0117" transform="matrix(0.866041 0.499972 -0.866041 0.499972 82.0312 64.3545)" fill="#AAAAAA"/>
<path d="M0.614258 93.7332L82.0293 140.742L82.0303 158.366L0.615297 111.358L0.614258 93.7332Z" fill="url(#paint1_linear_2001_189)"/>
<path d="M82.0317 140.74L163.447 93.7313L163.446 111.356L82.0307 158.364L82.0317 140.74Z" fill="url(#paint2_linear_2001_189)"/>
<rect x="0.866041" width="93.0117" height="93.0117" transform="matrix(0.866041 -0.499972 0.866041 0.499972 0.730272 94.1696)" fill="url(#paint3_linear_2001_189)" stroke="black"/>
<text transform="matrix(0.86601 0.500028 3.18351e-05 1 49.0146 0.674805)" fill="white" xmlSpace="preserve" style={{whiteSpace: "pre"}}  fontSize="58.5502" fontWeight="800" letterSpacing="0em"><tspan x="0" y="56.791">{quat}</tspan></text>
<g opacity="0.3" filter="url(#filter0_f_2001_189)">
<ellipse cx="79.9917" cy="98.3072" rx="37" ry="6" transform="rotate(25.4307 79.9917 98.3072)" fill="black"/>
</g>
<defs>
<filter id="filter0_f_2001_189" x="32.4761" y="67.5154" width="95.0312" height="61.5835" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_2001_189"/>
</filter>
<linearGradient id="paint0_linear_2001_189" x1="0" y1="177.5" x2="210" y2="177.5" gradientUnits="userSpaceOnUse">
<stop stopColor="white" stopOpacity="0.47"/>
<stop offset="1" stopColor="#020202"/>
</linearGradient>
<linearGradient id="paint1_linear_2001_189" x1="0.614538" y1="102.545" x2="82.0285" y2="102.543" gradientUnits="userSpaceOnUse">
<stop stopColor="#AEC330"/>
<stop offset="1" stopColor="#FBFF3B"/>
</linearGradient>
<linearGradient id="paint2_linear_2001_189" x1="82.031" y1="149.552" x2="163.445" y2="149.555" gradientUnits="userSpaceOnUse">
<stop stopColor="#AEC330"/>
<stop offset="1" stopColor="#FBFF3B"/>
</linearGradient>
<linearGradient id="paint3_linear_2001_189" x1="0" y1="47.0059" x2="94.0117" y2="47.0059" gradientUnits="userSpaceOnUse">
<stop stopColor="#FBFF3B"/>
<stop offset="1" stopColor="#AEC330"/>
</linearGradient>
</defs>
</svg>


      </>
   )
}
export default TextLeftActive;